import classname from "classnames";
import { useEffect } from "react";

const CellBooleanComponent = ({
	error,
	isReadOnly,
	schema,
	payload,
	parentProps,
	inputProps,
	setInputProps,
	updatePayload,
	validateSchema,
	getFieldValue,
}) => {
	const selectedValue = "yes";
	const unselectedValue = "no";

	useEffect(() => {
		const fieldValue = getFieldValue(payload, parentProps);
		setInputProps({
			...inputProps,
			value: fieldValue,
		});
	}, [payload]);

	function onClick(e) {
		if (isReadOnly) {
			return;
		}
		const value = e.target.value === selectedValue;
		setInputProps({ ...inputProps, value: value });
		updatePayload(value);
		validateSchema(value);
	}

	function getClassName(checked) {
		return classname({
			"eform-radio": true,
			"eform-radio-checked": checked,
			"eform-radio-disabled": isReadOnly,
		});
	}

	if (!inputProps || !Object.keys(inputProps).length) {
		return <></>;
	}

	return (
		<div
			className="eform-boolean-container"
			data-testid="eform-boolean-container"
		>
			<div className="flex-box flex-start flex-align-center">
				<input
					type="radio"
					onClick={onClick}
					disabled={isReadOnly}
					data-testid="eform-boolean-input-yes"
					className={getClassName(inputProps.value)}
					value={selectedValue}
					checked={inputProps.value}
				/>
				<label className="eform-radio-label">Yes</label>
			</div>
			<div className="flex-box flex-start flex-align-center">
				<input
					type="radio"
					onClick={onClick}
					disabled={isReadOnly}
					data-testid="eform-boolean-input-no"
					className={getClassName(!inputProps.value)}
					value={unselectedValue}
					checked={!inputProps.value}
				/>
				<label className="eform-radio-label">No</label>
			</div>
		</div>
	);
};

export default CellBooleanComponent;
